module.exports = __webpack_public_path__ + "static/tarot-bf412051d95ee644e0f849cab7ab7775.png";